module.exports = __webpack_public_path__ + "media/packs/images/black-arrow-4a9b6137a2e2db90a633eb6e064626e6.svg";